import React, { useState } from 'react';
import { HiDocumentAdd, HiOutlineMoon, HiOutlineLogout, HiOutlineSun, HiKey, HiOutlineMenu } from 'react-icons/hi';
import '../../css/nav.css';

const Header = ({ userArea, onAddPost, onLogout, darkMode, toggleDarkMode, setIsChangePasswordModalOpen }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className='navbar'>
      <h1 className='areaNamenav'>{userArea.toUpperCase()}</h1>
      <button className="hamburger" onClick={toggleMenu}>
        <HiOutlineMenu />
      </button>
      <div className={`header-buttons ${isMenuOpen ? 'active' : ''}`}>
        <button className="nav-link" onClick={onAddPost}><HiDocumentAdd /><span className="nav-label">Añadir</span></button>
        <button onClick={() => setIsChangePasswordModalOpen(true)} className="nav-link"><HiKey /><span className="nav-label">Cambiar contraseña</span></button>
        <button onClick={toggleDarkMode} className="nav-link dark-mode-toggle">
          {darkMode ? <HiOutlineSun /> : <HiOutlineMoon className="icon" />}
          <span className="nav-label">{darkMode ? 'Modo Diurno' : 'Modo Nocturno'}</span>
        </button>
        <button onClick={onLogout} className="nav-link logout-button"><HiOutlineLogout /><span className="nav-label">Cerrar sesión</span></button>
      </div>
    </header>
  );
};

export default Header;

